'use client'

import { useState } from 'react'
import { FC, inputStyle, labelStyle, submitStyle, FormSuccess, Honeypot } from './form-kit'

export function CareersForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [links, setLinks] = useState('')
  const [message, setMessage] = useState('')
  const [company, setCompany] = useState('') // honeypot
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [error, setError] = useState('')

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setState('sending')
    setError('')
    try {
      const res = await fetch('/api/careers', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ name, email, links, message, company }),
      })
      if (!res.ok) {
        const data = await res.json().catch(() => ({}))
        throw new Error(data.error || 'Something went wrong.')
      }
      setState('sent')
    } catch (err) {
      setState('error')
      setError(err instanceof Error ? err.message : 'Something went wrong.')
    }
  }

  if (state === 'sent') {
    return <FormSuccess title="Application received" body="Thanks for your interest — if there’s a fit, we’ll be in touch by email." />
  }

  return (
    <form onSubmit={onSubmit} noValidate>
      <div style={{ display: 'grid', gap: 16 }}>
        <div>
          <label htmlFor="kf-name" style={labelStyle}>Name</label>
          <input id="kf-name" style={inputStyle} value={name} onChange={(e) => setName(e.target.value)} required maxLength={120} autoComplete="name" />
        </div>
        <div>
          <label htmlFor="kf-email" style={labelStyle}>Email</label>
          <input id="kf-email" type="email" style={inputStyle} value={email} onChange={(e) => setEmail(e.target.value)} required maxLength={200} autoComplete="email" />
        </div>
        <div>
          <label htmlFor="kf-links" style={labelStyle}>Links <span style={{ color: FC.mute, fontWeight: 400 }}>(portfolio, LinkedIn, GitHub — optional)</span></label>
          <input id="kf-links" style={inputStyle} value={links} onChange={(e) => setLinks(e.target.value)} maxLength={500} placeholder="https://" />
        </div>
        <div>
          <label htmlFor="kf-message" style={labelStyle}>Tell us about yourself</label>
          <textarea id="kf-message" style={{ ...inputStyle, minHeight: 130, resize: 'vertical' }} value={message} onChange={(e) => setMessage(e.target.value)} required minLength={10} maxLength={5000} placeholder="What you do, what you’d love to work on, and why Papr." />
        </div>

        <Honeypot value={company} onChange={setCompany} />

        {state === 'error' ? <p style={{ fontSize: 13.5, color: FC.bad, margin: 0 }}>{error}</p> : null}

        <button type="submit" disabled={state === 'sending'} style={submitStyle(state === 'sending')}>
          {state === 'sending' ? 'Sending…' : 'Send application'}
        </button>
      </div>
    </form>
  )
}
